import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FlaggedMenuItemEvent } from '../interfaces/flagged-menu-item-event';

@Injectable({
    providedIn: 'root'
})
export class FlaggedMenuItemService {

    private flaggedEventSubject = new Subject<FlaggedMenuItemEvent>();

    flaggedEvent$: Observable<FlaggedMenuItemEvent> = this.flaggedEventSubject.asObservable();

    emitEvent(event: FlaggedMenuItemEvent) {
        this.flaggedEventSubject.next(event);
    }
}
